import { API_BASE_URL } from '../config/api';

/**
 * خدمة تتبع زيارات الصفحات بطريقة فائقة السرعة والأمان (Zero Latency Tracking)
 * تعتمد على navigator.sendBeacon مع بديل fetch في الخلفية
 */
export const analyticsService = {
  trackPageView(path) {
    if (typeof window === 'undefined') return;

    try {
      const url = `${API_BASE_URL}/stats/track`;
      const isMobile = /mobile|android|iphone|ipad|phone/i.test(navigator.userAgent || '');
      const payload = JSON.stringify({
        path: path || window.location.pathname || '/',
        referrer: document.referrer || '',
        device: isMobile ? 'mobile' : 'desktop',
      });

      // استخدام sendBeacon لعدم تعطيل المتصفح وضمان الإرسال حتى عند إغلاق أو تغيير الصفحة
      if (navigator.sendBeacon) {
        const blob = new Blob([payload], { type: 'application/json' });
        const success = navigator.sendBeacon(url, blob);
        if (success) return;
      }

      // بديل احتياطي باستخدام fetch بدون انتظار الرد (Fire-and-forget)
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    } catch (e) {
      // تجاهل أي خطأ لضمان عدم تأثر تجربة الزائر نهائياً
    }
  },
};
